import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Period from './types/Period';
import CodeableConcept from './types/CodeableConcept';
import ValueX from './types/ValueX';

export default class GroupCharacteristic extends BackboneElement {
    static __className = 'GroupCharacteristic';

    __objectStructure = {
        code: CodeableConcept,
        value: ValueX,
        exclude: Boolean,
        period: Period,
    };

    constructor(constructJson, className = 'GroupCharacteristic') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    get valueX() {
        return this.value ? this.value.internalValue : this.value;
    }

    // valueX Setter ONLY supports Boolean, Decimal, Integer and String along with the FHIR types:
    // Age, Attachment,CodeableConcept, Coding, Money, Period, Quantity, Range and Reference.
    // Assignment of FHIR type MUST be a FHIR entity NOT JSON.
    // Access to other ValueX supported type required standard ValueX access.
    set valueX(value) {
        if (!this.value) {
            this.value = new ValueX();
        }
        this.value.internalValue = value;
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
